﻿export class WorkTraySelectAllRequested {
    constructor(public selectAllPreference: string, public completedAction: () => void) {}

    static eventName() { return 'WorkTraySelectAllRequested'; }

    eventName = WorkTraySelectAllRequested.eventName;
}